import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicNavbar from '../../components/PublicNavbar';
import Footer from '../../components/Footer';

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('privacy.title', 'Privacy Policy')}</h1>
        <p className="text-sm text-gray-500 mb-8">{t('terms.lastUpdated', 'Last updated')}: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="prose prose-gray max-w-none">
          <h2>{t('privacy.s1Title', '1. Information We Collect')}</h2>
          <p>{t('privacy.s1Body', 'We collect information you provide directly: name, email address, company details, and shift scheduling data. We also collect usage data including page views, feature usage, and device information.')}</p>

          <h2>{t('privacy.s2Title', '2. How We Use Your Information')}</h2>
          <p>{t('privacy.s2Body', 'We use your information to: provide and maintain the Service, process your subscription, send notifications about schedules, improve our AI suggestions, and communicate service updates.')}</p>

          <h2>{t('privacy.s3Title', '3. Data Storage & Security')}</h2>
          <p>{t('privacy.s3Body', 'Your data is stored on Google Firebase (Google Cloud Platform) servers. We implement industry-standard security measures including encryption in transit and at rest, access controls, and regular security audits.')}</p>

          <h2>{t('privacy.s4Title', '4. Data Sharing')}</h2>
          <p>{t('privacy.s4Body', 'We do not sell your personal data. We share data only with: Stripe (payment processing), Google Firebase (infrastructure), and as required by law.')}</p>

          <h2>{t('privacy.s5Title', '5. GDPR Compliance')}</h2>
          <p>{t('privacy.s5Body', 'For users in the EU/EEA, you have the right to: access your personal data, rectify inaccurate data, request deletion of your data, restrict processing, data portability, and withdraw consent.')}</p>

          <h2>{t('privacy.s6Title', '6. Data Retention')}</h2>
          <p>{t('privacy.s6Body', 'We retain your data for as long as your account is active. Upon account deletion, we remove personal data within 30 days. Anonymised analytics data may be retained longer.')}</p>

          <h2>{t('privacy.s7Title', '7. Cookies')}</h2>
          <p>{t('privacy.s7Body', 'We use essential cookies for authentication and session management. We use analytics cookies (Google Analytics) to understand usage patterns. You can disable non-essential cookies in your browser settings.')}</p>

          <h2>{t('privacy.s8Title', '8. Cross-Product Data')}</h2>
          <p>{t('privacy.s8Body', 'If you also use BuildMyChecks, your company profile and user accounts are shared between products. Shift and check data remain separate within their respective product spaces.')}</p>

          <h2>{t('privacy.s9Title', "9. Children's Privacy")}</h2>
          <p>{t('privacy.s9Body', 'The Service is not intended for users under 16. We do not knowingly collect data from children.')}</p>

          <h2>{t('privacy.s10Title', '10. Changes to This Policy')}</h2>
          <p>{t('privacy.s10Body', 'We will notify you of material changes to this policy via email. Continued use of the Service after changes constitutes acceptance.')}</p>

          <h2>{t('privacy.s11Title', '11. Contact')}</h2>
          <p>{t('privacy.s11Body', 'For privacy enquiries or to exercise your data rights, contact our Data Protection Officer at')} <a href="mailto:privacy@buildmyshifts.com" className="text-primary">privacy@buildmyshifts.com</a>.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
